import React from "react";
import TextField from "@mui/material/TextField";

const FormTextBox = ({ value, initialValue, onChange, label, name }) => {
  return (
    <div>
      <TextField
        id="outlined-basic"
        value={value || ""}
        label={label}
        style={{ width: "300px" }}
        variant="standard"
        onChange={onChange}
        name={name}
      />
    </div>
  );
};

export default FormTextBox;
